<md-content-box class="lesson-block" [type]="isHomeworkInvalid() ? 'error' : 'default'">
	<md-icon icon="untitled-ui/education/backpack"></md-icon>
	<div class="lesson-block__body">
		<div class="lesson-block__header">
			<div class="lesson-block__title">
				<md-header size="xs">Homework</md-header>
				<span md-tooltip="Required grade" class="required">*</span>
			</div>
		</div>

		<div class="lesson-block__content">
			@if (!isReadOnly()) {
				<md-drop-down
					placeholder="Choose assignment category(s)"
					[multiple]="true"
					[disabled]="fieldsDisabled()"
					[options]="categoryOptions()"
					[value]="selectedCategoryIDs()"
					(change)="onCategoryChange($event)"
				></md-drop-down>

				<div class="homework-actions">
					@if (!showLinkForm()) {
						<button md-button type="button" [disabled]="fieldsDisabled()" (click)="toggleLinkForm()">
							<md-icon icon="untitled-ui/general/link-01"></md-icon>
							Add Link
						</button>
					}
				</div>

				@if (showLinkForm()) {
					<md-content-box type="tertiary" class="link-form">
						<input md-form-input type="text" placeholder="Link name" [value]="linkName()" (input)="linkName.set($any($event.target).value)" />
						<div class="link-form__url-row">
							<input md-form-input type="url" placeholder="https://..." [value]="linkUrl()" (input)="linkUrl.set($any($event.target).value)" />
							<button md-button-link type="button" class="link-form__paste-btn" (click)="pasteFromClipboard()" md-tooltip="Paste from clipboard">
								<md-icon icon="untitled-ui/general/copy-01"></md-icon>
							</button>
						</div>
						<div class="link-form__actions">
							<button md-button type="button" (click)="saveLink()" [disabled]="!linkName() || !linkUrl()">Save Link</button>
							<button md-button-link type="button" (click)="toggleLinkForm()">Cancel</button>
						</div>
					</md-content-box>
				}

				@if (homeworkLinks().length > 0) {
					<div class="homework-attachments">
						@for (link of homeworkLinks(); track link.url; let i = $index) {
							<md-content-box type="info" padding="sm" class="attachment-item">
								<md-icon icon="untitled-ui/general/link-01"></md-icon>
								<a class="attachment-item__name" [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.name }}</a>
								<button md-button-link type="button" class="attachment-item__remove" (click)="removeLink(i)">
									<md-icon icon="untitled-ui/general/x-close"></md-icon>
								</button>
							</md-content-box>
						}
					</div>
				}

				<lb-audio-transcribe-input [languageID]="state.lesson()?.languageID ?? null" [disabled]="fieldsDisabled()">
					<label label for="homework-instructions">Homework Notes</label>
					<textarea
						id="homework-instructions"
						placeholder="Add instructions for homework (optional)"
						[disabled]="fieldsDisabled()"
						[value]="instructions()"
						(input)="onInstructionsChange($any($event.target).value)"
					></textarea>
				</lb-audio-transcribe-input>
			} @else {
				<div class="homework-display">
					@if (selectedCategoryNames().length === 0 && !instructions() && homeworkLinks().length === 0) {
						<span class="empty-state">No homework recorded for this lesson.</span>
					} @else {
						@if (selectedCategoryNames().length > 0) {
							<div class="category-list">
								@for (name of selectedCategoryNames(); track name) {
									<md-tag class="category-name">{{ name }}</md-tag>
								}
							</div>
						}

						@if (homeworkLinks().length > 0) {
							<div class="field">
								<span class="field__label">Attachments</span>
								<div class="homework-attachments">
									@for (link of homeworkLinks(); track link.url) {
										<md-content-box type="tertiary" class="attachment-item">
											<md-icon icon="untitled-ui/general/link-01"></md-icon>
											<a class="attachment-item__name" [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.name }}</a>
										</md-content-box>
									}
								</div>
							</div>
						}

						@if (instructions()) {
							<md-content-box type="tertiary" class="notes">
								<div class="notes__header">
									<md-icon icon="untitled-ui/alerts/notification-text"></md-icon>
									<span>Instructions</span>
								</div>
								<lb-rich-text-view [content]="instructions()" />
							</md-content-box>
						}
					}
				</div>
			}
		</div>
	</div>
</md-content-box>
